<template lang="">
  <v-dialog v-model="show" max-width="1200" persistent v-if="show">
    <v-card style="padding:15px;">
      <v-card-title v-if="clientType != 'remitenteVentaCajas'">
        Búsqueda {{ clientType }}
      </v-card-title>
      <v-card-title v-if="clientType == 'remitenteVentaCajas'">Búsqueda cliente</v-card-title>
      <v-text-field
        prepend-inner-icon="mdi-magnify"
        dense
        autofocus
        @input="buscarClienteMostrador()"
        v-model="search"
        label="Búsqueda..."
        single-line
        solo
        clearable
      ></v-text-field>
      <v-data-table
        @click:row="rowClick"
        hide-default-footer
        :headers="headers"
        :items="cualArregloDeItemsRegresar"
        single-select
        item-key="ID"
      >
      </v-data-table>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" @click="cierraDialogo()" text>Cancelar</v-btn>
        <v-btn
          color="blue darken-1"
          @click="insertarCliente()"
          :disabled="this.selectedId === -1 ? true : false"
          text
          >Aceptar</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-overlay :value="loaderModalClientes">
      <v-progress-circular indeterminate size="100"></v-progress-circular>
    </v-overlay>
    <ModalClienteElegirDireccion
      @elegi-esta-direccion="eleccionDireccionLista($event)"
      :usuarioAChecarDirecciones="usuarioAChecarDirecciones"
      @cierraModalDirecciones="cierraModalDireccionesX"
      v-if="mostrarElegirDireccion"
      :show="mostrarElegirDireccion"
    />
  </v-dialog>
</template>
<script>
import _ from "lodash";
import { mapState, mapActions } from "vuex";
import ModalClienteElegirDireccion from "@/components/modales/ModalClienteElegirDireccion.vue";

export default {
  components: {
    ModalClienteElegirDireccion
  },
  name: "modalCliente",
  data: () => ({
    loaderModalClientes: false,
    usuarioAChecarDirecciones: {},
    mostrarElegirDireccion: false,
    search: "",
    selectedId: -1,
    headers: [
      {
        text: "Alias",
        align: "center",
        sortable: false,
        value: "ALIAS"
      },
      {
        text: "Nombre",
        align: "center",
        sortable: false,
        value: "NOMBRE_COMPLETO"
      },
      {
        text: "Teléfono",
        align: "center",
        sortable: false,
        value: "TELEFONO"
      },
      {
        text: "Sucursal",
        align: "center",
        sortable: false,
        value: "SUCURSAL"
      }
    ]
  }),
  props: {
    show: Boolean,
    clientType: String
  },
  computed: {
    ...mapState("destinatarioRegistro", {
      destinatariosMostradorList: state => state.destinatariosMostrador
    }),
    ...mapState("remitentesRegistro", {
      remitentesMostradorList: state => state.remitentesMostrador
    }),
    cualArregloDeItemsRegresar() {
      if (
        this.clientType == "remitente" ||
        this.clientType == "titular" ||
        this.clientType == "remitenteVentaCajas"
      ) {
        return this.remitentesMostradorList;
      }
      return this.destinatariosMostradorList;
    },
    cadenaBusqueda() {
      return this.search == null ? "" : this.search;
    }
  },
  async mounted() {
    await this.buscarClienteMostrador();
  },
  async beforeDestroy() {
    await this.destroyDestinatariosMostrador();
    await this.destroyRemitentesMostrador();
  },
  methods: {
    ...mapActions("destinatarioRegistro", [
      "getDestinatarioMostrador",
      "destroyDestinatariosMostrador"
    ]),
    ...mapActions("remitentesRegistro", ["getRemitenteMostrador", "destroyRemitentesMostrador"]),
    ...mapActions("enviosDestinatarios", ["chargeDestinatario", "destroyDestinatario"]),
    cierraModalDireccionesX() {
      this.mostrarElegirDireccion = false;
    },
    eleccionDireccionLista(dir) {
      const objetoDatos = { indice: dir, datos: this.selectedId };
      if (this.clientType == "remitente") {
        this.$emit("remitenteArreglo", objetoDatos);
      } else {
        this.$emit("destinatarioArreglo", objetoDatos);
      }
      this.cierraModalDireccionesX();
      this.cierraDialogo();
    },

    buscarClienteMostrador: _.debounce(async function() {
      console.log(this.clientType);
      if (
        this.clientType == "remitente" ||
        this.clientType == "titular" ||
        this.clientType == "remitenteVentaCajas"
      ) {
        console.log("holis");
        this.loaderModalClientes = true;
        const resR = await this.getRemitenteMostrador(this.cadenaBusqueda);
        if (resR[0]) {
          this.loaderModalClientes = false;
        }
      } else {
        this.loaderModalClientes = true;
        const resD = await this.getDestinatarioMostrador(this.cadenaBusqueda);
        if (resD[0]) {
          this.loaderModalClientes = false;
        }
      }
    }, 400),
    cierraDialogo() {
      if (this.clientType == "remitenteVentaCajas") {
        this.$emit("cierraModalClienteVentaCajas");
      } else {
        this.$emit("cierraModalCliente");
      }
    },
    rowClick(item, row) {
      row.select(true);
      this.selectedId = item;
    },
    insertarCliente() {
      if (this.clientType == "titular") {
        //console.log(this.selectedId.NOMBRE_COMPLETO);
        this.$emit("insertarNombreTitularCuenta", this.selectedId.NOMBRE_COMPLETO);
        this.cierraDialogo();
      } else if (this.clientType == "remitenteVentaCajas") {
        //VENTA DE CAJAS
        //VENTA DE CAJAS

        this.$emit("insertarClienteventaCajas", {
          nombre: this.selectedId.NOMBRE_COMPLETO,
          id: this.selectedId.ID
        });
        this.cierraDialogo();
      } else if (this.selectedId.DIRECCION.length >= 1) {
        const arregloSeleccionado = Array.from(JSON.parse(this.selectedId.DIRECCION));
        if (arregloSeleccionado.length > 1) {
          this.mostrarElegirDireccion = true;
          this.usuarioAChecarDirecciones = this.selectedId;
        } else if (this.clientType == "remitente") {
          this.$emit("insertarRemitente", this.selectedId);
          this.cierraDialogo();
        } else if (this.clientType == "destinatario") {
          this.$emit("insertarDestinatario", this.selectedId);
          this.cierraDialogo();
        }
      } else {
        if (this.clientType == "remitente") {
          this.$emit("insertarRemitente", this.selectedId);
          this.cierraDialogo();
        } else if (this.clientType == "destinatario") {
          this.$emit("insertarDestinatario", this.selectedId);
          this.cierraDialogo();
        }
      }
    }
  }
};
</script>
<style lang="css">
tr.v-data-table__selected {
  background: #7d92f5 !important;
  color: white !important;
  font-weight: bold !important;
}
.v-data-table .v-data-table__mobile-table-row {
  display: block !important;
}
</style>
